export function normalizeGtin(gtin?: string | number | null): string {
    const value = String(gtin ?? "")
        .trim()
        .replace(/\s+/g, "")
        .replace(/^0+/, "");

    return value || "0";
}
